import { useDeletionRequest } from './deletionRequestStore';
import { VersionPanel } from './VersionPanel';
export function DeletionRequestPanel({ showDetail, open }: { showDetail: boolean; open: () => void }) {
  const stored = useDeletionRequest();
  if (stored.storageFailed) return <p role="alert">Не удалось восстановить запрос удаления. Новые операции отключены; обратитесь к оператору.</p>;
  if (!stored.request) return null;
  return (
    <section className="map-generations__panel" aria-label="Сохранённое удаление">
      <h2>Сохранённое удаление</h2>
      <p className="map-generations__identifier">Сохранён запрос удаления версии {stored.request.version}. После перезагрузки отправка автоматически не повторяется.</p>
      {showDetail ? <VersionPanel key={stored.request.version} version={stored.request.version} /> : (
        <button className="workspace-secondary-button" type="button" onClick={open}>Открыть сохранённое удаление</button>
      )}
    </section>
  );
}
